export default __webpack_public_path__ + "static/media/goa_logo.174ca235.png";